import StorageManager from '../StorageManager'
import type { PhotoBookStorageBackend } from './photoBookStorageBackend.types'

// One key per book, so a book too big for the quota fails alone. The regex
// needs a character after the dash, which keeps the legacy `photo-book` key out.
const PHOTO_BOOK_SLOT_KEY_PREFIX = 'photo-book-'
const PHOTO_BOOK_SLOT_KEY_REGEX = /^photo-book-./

const getPhotoBookSlotKey = (bookId: string): string =>
  `${PHOTO_BOOK_SLOT_KEY_PREFIX}${bookId}`

export const localStoragePhotoBookBackend: PhotoBookStorageBackend = {
  name: 'local-storage',
  readAllRecords: async () =>
    StorageManager.getKeysByRegex(PHOTO_BOOK_SLOT_KEY_REGEX).map((slotKey) =>
      StorageManager.get<unknown>(slotKey)
    ),
  putBook: async (book) =>
    StorageManager.setOrThrow(getPhotoBookSlotKey(book.bookId), book),
  deleteBook: async (bookId) => {
    StorageManager.remove(getPhotoBookSlotKey(bookId))
  },
}
